var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#7BD5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 11H25a.5.5 0 00-.5.5v.404L9.477 15.388A.493.493 0 009 15h-.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5H9a.493.493 0 00.477-.388l3.595.834c-.037.18-.072.362-.072.554a3 3 0 003 3c1.381 0 2.531-.937 2.878-2.208l5.622 1.304v.404a.5.5 0 00.5.5h.5a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM16 23.5c-.827 0-1.5-.673-1.5-1.5 0-.076.028-.142.04-.214l2.882.668A1.497 1.497 0 0116 23.5zm-6.5-4.422v-2.156l15-3.479v9.113l-15-3.478z",
    fill: "#3C6C55"
  })));
}

export default __webpack_public_path__ + "./fonts/megaphone.f760b95055ab31e241d35230708b41de.svg";
export { SvgMegaphone as ReactComponent };